<template>
  <div class="egg">
    <img class="egg__image" :src="require(`@/assets/practices/expanded_form/${eggColor}.svg`)" alt="egg" />
    <div class="egg__number">{{ eggNumber }}</div>
  </div>
</template>

<script>
export default {
  name: 'Egg',
  props: {
    eggAnswer: Boolean,
    eggColor: String,
    eggNumber: Number,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.egg {
  @include flex-center;
  font-family: 'VanillaExtractRegular';
  // cursor: pointer;

  &__image {
    height: 33vh;
    // width: 38vh;
  }

  &__number {
    @include flex-center;
    // font-size: 4.5vw;
    font-size: 175%;
    padding: 0.25em 0.25em;
    position: absolute;
    transform: translateY(-1vh);
    -webkit-text-stroke: 2.5px black;
    z-index: 2;
  }
}

// @media (max-aspect-ratio: 8/5) {
//   .egg {
//     &__image {
//       height: 32vh;
//       width: 35vh;
//     }

// &__number {
//   font-size: 6vw;
// -webkit-text-stroke: 2.5px black;
// }
//   }
// }
</style>
